document.addEventListener('DOMContentLoaded', function() {
  var drawerForm = document.querySelector('#localization_formdrawer');
  if (drawerForm) {
    // Initialize currency selector
    var currencyDisclosure = drawerForm.querySelector('[data-disclosure-currency]');
    if (currencyDisclosure) {
      new theme.Disclosure(currencyDisclosure);
    }
    // Initialize language selector
    var localeDisclosure = drawerForm.querySelector('[data-disclosure-locale]');
    if (localeDisclosure) {
      new theme.Disclosure(localeDisclosure);
    }
  }
});